import { render } from "./AllBilledCases.vue?vue&type=template&id=336bfb22"
import script from "./AllBilledCases.vue?vue&type=script&lang=js"
export * from "./AllBilledCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/AllBilledCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "336bfb22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('336bfb22', __exports__)) {
    console.log('reload')
    api.reload('336bfb22', __exports__)
  }
  
  module.hot.accept("./AllBilledCases.vue?vue&type=template&id=336bfb22", () => {
    console.log('re-render')
    api.rerender('336bfb22', render)
  })

}


export default __exports__